import { useEffect, useState } from "react";

/**
 * YENİ SÜRÜM UYARISI.
 *
 * Ofiste ve atölyede Balder sekmesi gün boyu açık kalıyor; yayına alınan
 * düzeltme, sayfa yenilenene kadar o ekranlara ULAŞMIYOR. Burada birkaç
 * dakikada bir `index.html` önbelleksiz okunur ve içindeki ana betik adı
 * (Vite her derlemede adı değiştirir) şu an çalışanla karşılaştırılır.
 * Fark varsa sağ altta "Yeni sürüm hazır — Yenile" kutusu çıkar; sayfa
 * kullanıcı istemeden YENİLENMEZ (yarım kalmış formu kaybetmesin).
 */
const CHECK_MS = 5 * 60 * 1000;

function currentBundle(): string | null {
  const el = document.querySelector<HTMLScriptElement>('script[type="module"][src*="/assets/"]');
  return el ? new URL(el.src, location.href).pathname : null;
}

export function UpdateNotice() {
  const [ready, setReady] = useState(false);

  useEffect(() => {
    const mine = currentBundle();
    if (!mine) return; // geliştirme sunucusunda paket adı yok
    let stopped = false;

    const check = async () => {
      try {
        const res = await fetch("/index.html", { cache: "no-store" });
        if (!res.ok) return;
        const html = await res.text();
        const m = html.match(/<script[^>]+type="module"[^>]+src="([^"]+\/assets\/[^"]+)"/);
        if (!stopped && m?.[1] && new URL(m[1], location.href).pathname !== mine) setReady(true);
      } catch {
        // Ağ yoksa bir sonraki denemede tekrar bakılır.
      }
    };

    const t = window.setInterval(check, CHECK_MS);
    const onFocus = () => void check();
    window.addEventListener("focus", onFocus);
    return () => {
      stopped = true;
      window.clearInterval(t);
      window.removeEventListener("focus", onFocus);
    };
  }, []);

  if (!ready) return null;
  return (
    <div
      role="status"
      className="noprint fixed bottom-4 right-4 z-[55] flex animate-fade-in items-center gap-3 rounded-xl bg-gray-950 py-2.5 pl-4 pr-2.5 text-sm text-white shadow-pop"
    >
      <span className="h-2 w-2 rounded-full bg-emerald-400" aria-hidden="true" />
      Balder&apos;in yeni sürümü hazır.
      <button
        type="button"
        onClick={() => location.reload()}
        className="rounded-lg bg-white px-3 py-1.5 text-sm font-semibold text-gray-950 hover:bg-gray-100"
      >
        Yenile
      </button>
    </div>
  );
}
